<template>
  <div></div>
</template>

<script>
import Service from "@/services";
import { dateTime } from "@/utils/helpers";

export default {
  name: "signal-r",
  data() {
    return {};
  },
  mounted: function() {
    let markers = [];

    Service.get("/Tracking/AllLocations")
      .then(function(response) {
        response.data.forEach(it => {
          markers.push({
            userId: it.userId,
            userName: it.userName,
            position: {
              lat: it.locationVm.latitude,
              lng: it.locationVm.longitude
            },
            tooltip: `${it.userName}: ${dateTime(it.date)}`,
            draggable: false,
            visible: true,
            date: it.date,
            accuracy: it.locationVm.accuracy,
            speed: it.locationVm.speed
          });
        });
      })
      .catch(function(error) {
        console.log(error);
      });

    var connection = new signalR.HubConnectionBuilder()
      .withUrl(`${process.env.VUE_APP_BACKEND_URL}/localize`, {
        accessTokenFactory: () => sessionStorage.getItem("token")
      })
      .configureLogging(signalR.LogLevel.Error)
      .build();

    connection
      .start()
      .then(() => console.log("Connection started!"))
      .catch(err => console.log("Error while establishing connection" + err));

    connection.on("broadcastLocation", userLocation => {
      _.find(markers, function(o) {
        if (o.userId == userLocation.userId) {
          o.position = {
            lat: userLocation.locationVm.latitude,
            lng: userLocation.locationVm.longitude
          };
          o.tooltip = `${userLocation.userName}: ${dateTime(
            userLocation.date
          )}`;
          o.accuracy = userLocation.locationVm.accuracy;
          o.speed = userLocation.locationVm.speed;
          o.date = userLocation.date;
        }
      });
    });
  }
};
</script>

<style scoped>
</style>
